import React from "react";
import type { DynamicStructure } from "../../../utils/interpolate";
import { resolveSeeAllUrl } from "../logic";
import { STRINGS } from "../strings";
import { Arrow } from "./Icons";
import { MegaMenuFooter, MegaMenuSeeAll } from "../HeaderV2.styles";
import type { HeaderV2Link } from "../types";

type MegaMenuSeeAllLinkProps = {
  link: HeaderV2Link;
  structure?: DynamicStructure;
  onNavigate: () => void;
};

export const MegaMenuSeeAllLink = ({ link, structure, onNavigate }: MegaMenuSeeAllLinkProps) => {
  const item = link.megaMenu;
  const url = resolveSeeAllUrl({ link, structure });
  const label = item?.seeAllLabel ?? STRINGS.seeAllDefault(link.name);
  if (item?.showSeeAll === false || url === "#" || !label.trim()) return null;

  const opensInNewTab = !!item?.seeAllRedirect?.openInNewTab;

  return (
    <MegaMenuFooter>
      <MegaMenuSeeAll
        href={url}
        target={opensInNewTab ? "_blank" : undefined}
        rel={opensInNewTab ? "noopener noreferrer" : undefined}
        onClick={onNavigate}
      >
        {label}
        <Arrow />
      </MegaMenuSeeAll>
    </MegaMenuFooter>
  );
};
